import moment from "moment";

export const formatDateToInput = (date: Date | null): string => {
  if (!date) return "";
  const offset = date.getTimezoneOffset();
  const adjustedDate = new Date(date.getTime() - offset * 60000);
  return adjustedDate.toISOString().slice(0, 16);
};

export const getCurrentDateTimeLocal = ():string =>{
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16);

}
export const openBase64ImageInNewTab = (base64: string) => {
    const [header, data] = base64.split(",");
    const mimeMatch = header.match(/data:(.*);base64/);
    if (!mimeMatch) return;
  
    const mime = mimeMatch[1];
    const binary = atob(data);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
  
    const blob = new Blob([array], { type: mime });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank", "noopener,noreferrer");
  };

  export  const hasEmptyField = (formValues:any) =>  Object.values(formValues).some((value) => {
    return (
      value === "" ||
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (Array.isArray(value) && value.length === 0)
    );
  });
  
  export  const formatIfISO = (value:string, format:string):string => /z|Z|GMT-/.test(value) ? moment(value).format(format) : value;